import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0dd42006&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd42006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd42006')) {
      api.createRecord('0dd42006', component.options)
    } else {
      api.reload('0dd42006', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0dd42006&scoped=true", function () {
      api.rerender('0dd42006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/overview/index.vue"
export default component.exports